import React from 'react'
import styled, { css } from 'styled-components'
import { Link, useSearchParams } from 'react-router-dom'
import { Noto_body1_b16 } from 'src/styles/font/NotoSansKrFonts'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage'
import { useFormContext } from 'react-hook-form'
import { JoinFormType } from 'src/types/react-hook-form'
import { UIInfoSpace } from 'src/types/api'

const ShapeCheckBoxAgency = ({
  resetFormItems,
  layoutsInsert,
  blockTelList,
}: Pick<DefaultJoinFormPageProps, 'resetFormItems' | 'blockTelList'> &
  Pick<UIInfoSpace.UIDataType, 'layoutsInsert'>) => {
  const { pCode, fixedTelecom, requestIdPath, form, telecom } = useParamsList()
  const { getValues, setFocus } = useFormContext<JoinFormType>()

  const [searchParams] = useSearchParams()
  const search_params = `?${searchParams.toString()}`

  const checkBoxItemsProps = (telecomValue: '0' | '1' | '2') => ({
    to: `/${form}/${pCode}/${requestIdPath}/${telecomValue}${search_params}`,
    $telecom: telecomValue,
    $fixedTelecom: telecomValue === fixedTelecom,
    $isFixedTelecom: !!fixedTelecom,
    $layoutsInsert_agency_actColor: layoutsInsert?.agency?.actColor,
    $disabled: getValues('TranID') !== '' || blockTelList?.includes(telecomValue),
    $active: telecomValue === telecom,
    onClick: () => {
      setFocus('PNumber')
      resetFormItems()
    },
    replace: true,
  })

  return (
    <CheckBoxAgency.Container id="agencyTabList">
      { !blockTelList?.includes('0') && <CheckBoxAgency.CheckBoxItem {...checkBoxItemsProps('0')}>SKT</CheckBoxAgency.CheckBoxItem> }
      { !blockTelList?.includes('1') && <CheckBoxAgency.CheckBoxItem {...checkBoxItemsProps('1')}>KT</CheckBoxAgency.CheckBoxItem> }
      { !blockTelList?.includes('2') && <CheckBoxAgency.CheckBoxItem {...checkBoxItemsProps('2')}>LG U+</CheckBoxAgency.CheckBoxItem> }
    </CheckBoxAgency.Container>
  )
}

export default ShapeCheckBoxAgency

const CheckBoxAgency = {
  Container: styled.div`
    width: 100%;
    height: 50px;
    display: flex;
  `,
  CheckBoxItem: styled(Link)<{
    $isFixedTelecom?: boolean
    $fixedTelecom?: boolean
    $disabled?: boolean
    $layoutsInsert_agency_actColor?: string
    $active?: boolean
    $telecom?: '0' | '1' | '2'
  }>`
    position: relative;
    flex: 1;
    padding: 12px 10px;
    border: 1px solid var(--black-20);
    background-color: var(--white);
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    display: flex;
    color: var(--black-50);

    &:first-child {
      border-radius: 12px 0 0 12px;
    }

    &:last-child {
      border-radius: 0 12px 12px 0;
    }

    ${(props) =>
      props.$active &&
      css`
        ${Noto_body1_b16};
        color: var(--brand-50);
        border: 1px solid var(--brand-40);
        background-color: ${props.$layoutsInsert_agency_actColor || 'var(--brand-5)'};
        outline: 1px solid var(--brand-40);
      `};

    ${(props) =>
      props.$isFixedTelecom &&
      css`
        ${props.$fixedTelecom &&
        css`
          border-radius: 0 !important;
          ${Noto_body1_b16};
          color: var(--brand-50);
          border: 1px solid var(--brand-40);
          background-color: var(--brand-5);
          outline: 1px solid var(--brand-40);
          pointer-events: none;
        `}
        ${!props.$fixedTelecom &&
        css`
          display: none;
        `}
      `}

    ${(props) =>
      props.$disabled &&
      css`
        pointer-events: none;
        border: 1px solid var(--black-20);
        &:after {
          content: '';
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: 0.6;
          ${props.$telecom === '0' &&
          css`
            border-radius: 12px 0 0 12px;
          `};
          ${props.$telecom === '1' &&
          css`
            border-radius: 0;
          `};
          ${props.$telecom === '2' &&
          css`
            border-radius: 0 12px 12px 0;
          `};
        }
      `}
  `,
}
